/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_Captain_Action_DescInputs */

const es_nav_m_captain_action_desc = /** @type {(inputs: Nav_M_Captain_Action_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístrate como capitán`)
};

const gl_nav_m_captain_action_desc = /** @type {(inputs: Nav_M_Captain_Action_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexístrate como capitán`)
};

const en_nav_m_captain_action_desc = /** @type {(inputs: Nav_M_Captain_Action_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register as a captain`)
};

/**
* | output |
* | --- |
* | "Register as a captain" |
*
* @param {Nav_M_Captain_Action_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_captain_action_desc = /** @type {((inputs?: Nav_M_Captain_Action_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_Captain_Action_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_captain_action_desc(inputs)
	if (locale === "en") return en_nav_m_captain_action_desc(inputs)
	return es_nav_m_captain_action_desc(inputs)
});